<template>
    <v-row
            v-if="appointment"
            dense
            class="text-center">
        <v-col cols="12">
            <v-card>
                <v-card-title>{{ amountString }}</v-card-title>
                <v-card-subtitle
                        v-if="field.charge_amount.notice"
                        class="text-left"
                        style="white-space: pre-wrap;"
                        v-text="field.charge_amount.notice" />
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import Value from "@/models/value.model";
    import Field from "@/models/field.model";
    import Currency from "@/models/currency.model";
    
    export default {
        name: "FieldChargeAmountComponent",
        props: {
            field: {type: Object, default: () => new Field()},
        },
        computed: {
            appointment() {
                return this.$store.forms.getAppointment();
            },
            currency() {
                return this.appointment.currency;
            },
            amount() {
                if (!this.appointment) {
                    return null;
                }
                switch (this.field.charge_amount.type) {
                case 'custom':
                    return parseFloat(this.field.charge_amount.value) > 0
                        ? parseFloat(this.field.charge_amount.value)
                        : .0;
                case 'booking_total':
                    return this.appointment.total && this.appointment.total.outstanding && parseFloat(this.appointment.total.sub_total) > 0
                        ? parseFloat(this.appointment.total.sub_total)
                        : .0;
                case 'booking_outstanding':
                    return this.appointment.total && this.appointment.total.outstanding && parseFloat(this.appointment.total.outstanding) > 0
                        ? parseFloat(this.appointment.total.outstanding)
                        : .0;
                default:
                    return .0;
                }
            },
            amountString() {
                const ccy = new Currency({iso: this.currency})
                return ccy.displayAmount(this.amount)
            },
        },
        mounted() {
            this.getValue().then(val => this.$emit('updateValue', val))
            this.$emit('updateValue', this.getValue())
        },
        methods: {
            /**
             *
             * @returns {Value}
             */
            async getValue() {
                return new Value({
                    value: this.amount,
                    isValid: true
                });
            }
        }
    }
</script>
<style scoped>
 .question-tips-employee {
    border-radius: 100%;
    border-top-left-radius:  100% !important;
    border-top-right-radius:  100% !important;
}
</style>